import React, { useEffect, useState } from "react";
import {
  List,
  Collapse,
  ListItemText,
  ListItemButton,
  Tooltip,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CircleIcon from "@mui/icons-material/Circle";
import {
  matchPath,
  useLocation,
  NavLink as RouterLink,
} from "react-router-dom";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { s3baseUrl } from "src/config/config";

export default function NavSectionItem({ data, searchInput }) {
  const { userInfo } = useContentSetting();
  const { pathname } = useLocation();
  const [openDropdown, setOpenDropdown] = useState(false);

  const match = ({ path, matches }) => {
    if (matches) {
      let is_active = false;
      matches.forEach((match_path) => {
        const match = match_path
          ? !!matchPath({ path: match_path, end: false }, pathname)
          : false;

        if (match) {
          is_active = true;
        }
      });
      return is_active;
    }
    return path ? !!matchPath({ path, end: false }, pathname) : false;
  };

  const handle_open_link = (data) => {
    if (data.is_open_new_tab) {
      window.open(data.path);
    } else {
      window.open(data.path, "_self");
    }
  };

  const handleClickDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  useEffect(() => {
    //On reload dropdown should not close
    if (data.child_options && data.child_options.length > 0) {
      data.child_options?.map((child_option) => {
        if (child_option.matches) {
          child_option.matches.map((match) => {
            const is_match_path = window.location.pathname.includes(match);
            if (is_match_path || searchInput) {
              setOpenDropdown(true);
            }
          });
        }
        const is_path = window.location.pathname.includes(child_option.path);
        if (
          is_path ||
          searchInput ||
          data.value == "members" ||
          data.value == "payments" ||
          data.value == "support"
        ) {
          setOpenDropdown(true);
        }
      });
    }
  }, [searchInput, pathname]);

  return (
    <>
      <ListItemButton
        component={data.is_link ? "" : data.path ? RouterLink : "span"}
        target={data.is_open_new_tab ? "_blank" : undefined}
        to={data.is_link ? "" : data.path ? data.path : ""}
        sx={{ pl: 5, fontSize: "14px" }}
        onClick={() => {
          if (data.is_link) {
            handle_open_link(data);
          } else {
            handleClickDropdown();
          }
        }}
        className={
          match({ path: data.path, matches: data.matches })
            ? "menuActive menus-list"
            : "menus-list"
        }
      >
        {data.icon && (
          <img
            src={s3baseUrl + data.icon}
            width={28}
            height={28}
            className="navbar-icon"
          />
        )}
        <ListItemText
          primaryTypographyProps={{ fontSize: "14px" }}
          primary={data.title}
        />
        {data.path === "/support-ticket" &&
          userInfo.is_sidebar_notify === true && (
            <Tooltip title="You have an activity to your Support Ticket">
              <CircleIcon className="support_notification_sidebar" />
            </Tooltip>
          )}

        {data.path === "/internal-tickets" &&
          userInfo.is_internal_ticket_notify === true && (
            <Tooltip title="You have an activity to your Internal Ticket">
              <CircleIcon className="support_notification_sidebar" />
            </Tooltip>
          )}

        {/* This will only work in case of dropdown*/}
        {data.child_options &&
          data.child_options.length > 0 &&
          (openDropdown ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      {/* This will only work in case of dropdown*/}
      {data.child_options && data.child_options.length > 0 && (
        <Collapse in={openDropdown} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {data.child_options.map((child_option, index) => {
              return (
                <ListItemButton
                  component={
                    child_option.is_link
                      ? ""
                      : child_option.path
                      ? RouterLink
                      : "span"
                  }
                  target={child_option.is_open_new_tab ? "_blank" : undefined}
                  to={child_option.is_link ? "" : child_option.path}
                  onClick={() => {
                    if (child_option.is_link) {
                      handle_open_link(child_option);
                    }
                  }}
                  key={index}
                  sx={{
                    pl: 8,
                    color: "black",
                    fontSize: "10px",
                  }}
                  className={
                    match({
                      path: child_option.path,
                      matches: child_option.matches,
                    })
                      ? "menuActive menus-list"
                      : "menus-list"
                  }
                >
                  {child_option.icon && (
                    <img
                      src={s3baseUrl + child_option.icon}
                      width={28}
                      height={28}
                      className="navbar-icon"
                    />
                  )}
                  <ListItemText
                    primaryTypographyProps={{ fontSize: "14px" }}
                    primary={child_option.title}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
}
